import React, {useEffect, useState} from 'react';
import {Checkbox, TextField} from '@material-ui/core';
import {gtmService} from '../../../../utils/gtm.service';
import {StepperButtons} from '../../brand/components/StepperButtons';
import {Col, Form, Row} from 'react-bootstrap';
import {useTranslation} from 'react-i18next';
import {IRegisterStepperProps} from '../dto/IRegisterStepperProps';
import {IRegisterInfluencer} from '../dto/IRegisterInfluencer';
import {AiFillEye, AiOutlineEyeInvisible} from 'react-icons/ai';
import {AuthService} from '../../../service';
import {ErrorToast, SuccessToast, WarningToast} from '../../../../utils/toasters';
import {useHistory} from 'react-router-dom';
import {InternalRoutes} from '../../../../enum/InternalRoutes';
import {useRecaptcha} from '../../../../shared/hooks/useRecaptcha';
import {PasswordVerifySteps} from '../../../../shared/PasswordVerifySteps';
import {useSelector} from 'react-redux';
import {IAllStates} from '../../../../store/rootReducer';

export function InfluencerStep1({stepIdNumber, handleBackStep}: IRegisterStepperProps) {
    const {agencyCompany} = useSelector((state: IAllStates) => state.influencerRegistration);
    const [isLoading, setIsLoading] = useState(false);
    const [isTypePassword, setIsTypePassword] = useState(true);
    const [isRepeatHidden, setIsRepeatHidden] = useState(true);
    const [registerInfluencer, setRegisterInfluencer] = useState<IRegisterInfluencer>({
        displayName: '',
        email: '',
        isGeneralTermsAccepted: false,
        password: '',
        repeatPassword: '',
    });
    const {t} = useTranslation();
    const history = useHistory();
    const {setToken, executeRecaptcha} = useRecaptcha();

    useEffect(() => {
        setRegisterInfluencer(prevState => (
            {
                ...prevState,
                agencyCompany: agencyCompany?.agency,
                email: agencyCompany?.email ?? ''
            }));
    }, [agencyCompany]);
    const changeHandler = (event: React.ChangeEvent<HTMLInputElement>, isCheckbox = false) => {
        const {name, value, checked} = event.target;
        setRegisterInfluencer((prev) => ({
            ...prev,
            [name]: isCheckbox ? checked : value,
        }));
    };
    const handleNextStep = async () => {

        if (!executeRecaptcha) {
            return;
        }
        const result = await executeRecaptcha('register');
        setToken(result);
        if (registerInfluencer?.isGeneralTermsAccepted) {
            setIsLoading(true);
            AuthService.registerInfluencer({
                ...registerInfluencer,
            }).then(response => {
                if (response) {
                    gtmService('influencer_lead');
                    history.push(`${InternalRoutes.INFLUENCER_REGISTRATION}/${stepIdNumber + 1}?token=${response?.verificationUUID}`);
                    SuccessToast(t('auth.register.brand.step1.pleaseCheckEmail'));
                }
            }).catch(error => ErrorToast(error)).finally(() => setIsLoading(false));
        } else {
            WarningToast(t('auth.register.brand.step1.termsNotSelected'));
        }
    };

    return (
        <Form onSubmit={(e) => {
            e.preventDefault();
            handleNextStep();
        }}>
            <Row>
                <Col md={6}>
                    <TextField
                        label={t('auth.register.influencer.step1.creator_name')}
                        variant="outlined"
                        size="small"
                        required
                        name="displayName"
                        onChange={changeHandler}
                        className="w-100 my-2"
                    />
                </Col>
                <Col md={6}>
                    <TextField
                        label="E-mail"
                        variant="outlined"
                        size="small"
                        required
                        type="email"
                        value={registerInfluencer.email}
                        name="email"
                        disabled={!!agencyCompany?.email}
                        onChange={changeHandler}
                        className="w-100 my-2"
                    />
                </Col>
                <Col md={6}>
                    <div className="d-flex align-items-center">
                        <TextField
                            label={t('auth.register.influencer.step1.password')}
                            variant="outlined"
                            size="small"
                            required
                            defaultValue={registerInfluencer?.password ?? ''}
                            name="password"
                            onChange={changeHandler}
                            type={isTypePassword ? 'password' : 'text'}
                            className="w-100 my-2"
                        />
                        <div className="cursor-pointer ml-1"
                             onClick={() => setIsTypePassword(prev => !prev)}>
                            {isTypePassword ? <AiFillEye size={20}/> :
                                <AiOutlineEyeInvisible size={20}/>}
                        </div>
                    </div>
                    <PasswordVerifySteps password={registerInfluencer?.password}/>
                </Col>
                <Col md={6}>
                    <div className="d-flex align-items-center">
                        <TextField
                            label={t('auth.register.influencer.step1.repeatPassword')}
                            variant="outlined"
                            required
                            onChange={changeHandler}
                            type={isRepeatHidden ? 'password' : 'text'}
                            size="small"
                            name="repeatPassword"
                            className="w-100 my-2"
                        />
                        <div className="cursor-pointer ml-1"
                             onClick={() => setIsRepeatHidden(prev => !prev)}>
                            {isRepeatHidden ? <AiFillEye size={20}/> :
                                <AiOutlineEyeInvisible size={20}/>}
                        </div>
                    </div>
                </Col>
                <div className="col-12 my-2 d-flex align-items-center">
                    <Checkbox defaultChecked={false} className="px-0"
                              onChange={(e) => {
                                  changeHandler(e, true);
                              }}
                              size={'small'}
                              id="checkbox"
                              name="isGeneralTermsAccepted"
                              color="primary"/>
                    <label htmlFor="checkbox" className="ml-2 mb-0 text-left cursor-pointer"
                           dangerouslySetInnerHTML={{__html: t('auth.register.influencer.step1.terms')}}/>
                </div>
                <div className="col-12 mt-4">
                    <StepperButtons currentStep={stepIdNumber - 1} handleNextStep={handleNextStep} isLoading={isLoading}
                                    handleBackStep={handleBackStep}/>
                </div>
            </Row>
        </Form>
    );
}
